"use client";

import { Text } from "@pamperedchef/design-system";

import * as styles from "./SectionStub.module.scss";

export interface SectionStubProps {
	/** The section this stands in for, as the design names it. */
	name: string;
	/** Roughly what the finished section occupies, so page rhythm is right. */
	height?: "sm" | "md" | "lg";
	/** Renders as one grid cell rather than a full-width band. */
	variant?: "band" | "tile";
}

export function SectionStub({
	name,
	height = "md",
	variant = "band"
}: SectionStubProps): JSX.Element {
	return (
		<div
			className={[
				styles["stub"],
				styles[`stub--${variant}`],
				styles[`stub--${height}`]
			].join(" ")}
			data-component="SectionStub"
			data-section={name}
		>
			<Text tag="span" className={styles["stub__label"]}>
				{name}
			</Text>
			<Text tag="span" className={styles["stub__note"]}>
				Not built yet
			</Text>
		</div>
	);
}
